<template>
    <div class="settings-page">
        <div class="page-header">
            <h4>Advanced Settings</h4>
            <ol class="breadcrumbs">
                <li class="breadcrumb-item home">
                    <router-link to="/">Home</router-link>
                </li>
                <li class="breadcrumb-item active">Advanced Settings</li>
            </ol>
        </div>
        <div class="settings-body">
            <tabs ref="settings-table" cache-lifetime="0" @changed="onMainTabChange">
              <tab v-if="!isUserRoleAssessor && !isUserRoleLawyer"  name="Users" id="settings-users" ref="settingsUsersTab" :class-name="'tab-content-table'">
                <Users
                    :myAccountDropzoneOptions="myAccountDropzoneOptions"
                    :onCurrentUserSelected="onCurrentUserSelected"
                    :is-adding-user="isAddNewUserClicked"
                    :add-user-trigger="addUserTrigger"
                    :cancel-adding-user="() => { this.isAddNewUserClicked = false }"
                ></Users>
              </tab>
              <tab name="My Account" id="settings-account" :class-name="'tab-content-table'">
                <my-account :myAccountDropzoneOptions="myAccountDropzoneOptions"></my-account>
              </tab>
                <tab v-if="!isUserRoleAssessor  && !isUserRoleLawyer"  name="Business Profile"
                     id="settings-business-profile"
                     :class-name="'tab-content-table'"
                >
                    <BusinessProfile ref="SettingsBusinessProfile"
                                     :onBusinessTabChange="onBusinessTabChange"
                                     @onClickRemoveRow="onClickRemoveRow"
                                     @onClickSaveRow="onClickSaveRow"
                                     @onClickEditRow="onClickEditRow"
                                     :add-location-button-pressed="isAddLocationPressed"
                                     :save-location-button-pressed="isSaveLocationPressed"
                    ></BusinessProfile>
                </tab>
                <tab v-if="!isUserRoleAssessor  && !isUserRoleLawyer"  name="Integrations"
                     id="settings-integrations"
                     :class-name="'tab-content-table'"
                >

                  <div class="row business-details">
                    <div class="col-md-6">
                      <div class="card mt-3">
                        <div class="card-header">Xero Integration</div>
                        <div class="card-block mt-3">
                          <div class="form-group row">
                            <label class="col col-form-label col-lg-4">
                              Xero status:
                              <span v-show="!originalCompanyInfo.activeXeroAuth" class="text-danger">not connected</span>
                              <span v-show="originalCompanyInfo.activeXeroAuth" class="text-success">connected</span>
                            </label>
                            <div class="col-lg-8">
                              <a v-show="!originalCompanyInfo.activeXeroAuth" href="#" class="btn btn-primary" @click.prevent="connectToXero">Connect to XERO</a>
                              <a v-show="originalCompanyInfo.activeXeroAuth" href="#" class="btn btn-danger btn-sm" @click.prevent="disconnectFromXero">Disconnect</a>
                            </div>
                          </div>


                          <div class="form-group row" v-show="originalCompanyInfo.activeXeroAuth">
                            <label class="col col-form-label col-lg-4">Selected Xero Company</label>
                            <div class="col-lg-8">
                              <b-form-select
                                  v-model="xeroAuth.tenantId"
                                  :options="xeroAuth.tenants"
                                  placeholder="Select Xero Company"
                              ></b-form-select>
                            </div>
                          </div>

                          <div class="form-group row" v-show="originalCompanyInfo.activeXeroAuth">
                            <label class="col col-form-label col-lg-4">Create New Invoice - (Default)</label>
                            <div class="col-lg-8">
                              <b-form-select
                                  v-model="xeroAuth.defaultInvoiceStatus"
                                  :options="xeroStatuses"
                                  placeholder="Select Xero Company"
                              ></b-form-select>
                            </div>
                          </div>

                          <div class="form-group row" v-show="originalCompanyInfo.activeXeroAuth">
                            <label class="col col-form-label col-lg-4">Invoice Reference Desc</label>
                            <div class="col-lg-8">
                              <b-form-select
                                  v-model="xeroAuth.invoiceReferenceDesc"
                                  :options="invoiceReferenceDescs"
                                  placeholder="Select Reference Desc"
                              ></b-form-select>
                            </div>
                          </div>

                          <div class="form-group row" v-show="originalCompanyInfo.activeXeroAuth">
                            <label class="col col-form-label col-lg-4">Invoice GST Setting</label>
                            <div class="col-lg-8">
                              <b-form-select
                                  v-model="xeroAuth.defaultGstSetting"
                                  :options="xeroGstSettings"
                                  placeholder="Select Xero Company"
                              ></b-form-select>
                            </div>
                          </div>

                          <div class="form-group row" v-show="originalCompanyInfo.activeXeroAuth">
                            <label class="col col-form-label col-lg-4">Line Item CODE</label>
                            <div class="col-lg-8">
                              <input v-model="xeroAuth.defaultLineItemCode" type="text"
                                     class="form-control" placeholder="Line item CODE" />
                            </div>
                          </div>

                          <div class="form-group row" v-show="originalCompanyInfo.activeXeroAuth">
                            <label class="col col-form-label col-lg-4">Due Date - (Default)</label>
                            <div class="col-lg-8">
                              <b-form-select
                                  v-model="xeroAuth.invoiceDueDate"
                                  :options="invoiceDueDates"
                                  text-field="label"
                                  value-field="value"
                                  placeholder="Default Due Date"
                              ></b-form-select>
                            </div>
                          </div>

                          <div class="form-group row" v-show="originalCompanyInfo.activeXeroAuth">
                            <label class="col col-form-label col-lg-4">Auto update Xero invoice</label>
                            <div class="col-lg-8">
                              <b-form-select
                                  v-model="xeroAuth.autoUpdateInvoice"
                                  :options="xeroToggleVariants"
                                  text-field="label"
                                  value-field="value"
                                  placeholder="Enable or disable feature"
                              ></b-form-select>
                            </div>
                          </div>

                          <div class="form-group row" v-show="originalCompanyInfo.activeXeroAuth">
                            <label class="col col-form-label col-lg-4">Auto delete/void Xero invoice</label>
                            <div class="col-lg-8">
                              <b-form-select
                                  v-model="xeroAuth.autoDeleteInvoice"
                                  :options="xeroToggleVariants"
                                  text-field="label"
                                  value-field="value"
                                  placeholder="Enable or disable feature"
                              ></b-form-select>
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>

                </tab>
                <tab v-if="!isUserRoleAssessor  && !isUserRoleLawyer"  name="Claims"
                     id="settings-claims"
                     :class-name="'tab-content-table'"
                >
                    <settings-claims ref="SettingsClaims">

                    </settings-claims>
                </tab>
                <template v-if="mainTabId === 'settings-users'" slot="nav-item-right">
                    <div class="tabs-nav-right-btn mr-1" v-if="isAddNewUserClicked">
                        <button class="white-save-btn" @click="onClickSaveUser()">Save</button>
                        <button class="white-save-btn" @click="onClickCancelEditUser()">Cancel
                        </button>
                    </div>
                    <div class="tabs-nav-right-btn">
                        <button class="btn btn-primary" v-if="!isAddNewUserClicked" @click="onClickAddNewUser()">
                            <i class="bx bx-plus"></i> Add User
                        </button>
                    </div>
                </template>
                <template v-if="mainTabId === 'settings-claims'"
                          slot="nav-item-right">
                    <div class="tabs-nav-right-btn">
                        <button @click="$refs.SettingsClaims.clickSave()" class="btn btn-primary primary-save-btn">Save</button>
                    </div>
                </template>
                <template v-if="mainTabId === 'settings-business-profile' && businessTabId === 'settings-business-profile-details'"
                          slot="nav-item-right">
                    <div class="tabs-nav-right-btn">
                        <button @click="$refs.SettingsBusinessProfile.clickSaveBusinessDetails()" class="btn btn-primary primary-save-btn">Save</button>
                    </div>
                </template>
                <template v-if="mainTabId === 'settings-business-profile' && businessTabId === 'settings-business-profile-contacts'"
                          slot="nav-item-right">
                    <div class="tabs-nav-right-btn">
<!--                        <button @click="$refs.SettingsBusinessProfile.clickSaveBusinessContacts()" class="btn btn-primary primary-save-btn">Save</button>-->
                    </div>
                </template>
                <template v-if="mainTabId === 'settings-business-profile' && businessTabId === 'settings-business-profile-locations'"
                          slot="nav-item-right">
                    <div class="tabs-nav-right-btn">
                        <button class="white-save-btn" @click="$refs.SettingsBusinessProfile.clickSaveBusinessLocation()">Save</button>
                    </div>
                    <div class="tabs-nav-right-btn">
                        <button href="#" class="add-location-btn" @click="onClickAddLocation()">
                            <i class="bx bx-plus"></i> Add Location
                        </button>
                    </div>
                </template>

            </tabs>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import NProgress from "nprogress";
    import Multiselect from 'vue-multiselect';
    import {email} from "vuelidate/lib/validators";
    import _ from "lodash";
    import {mapActions, mapGetters} from "vuex";
    import vue2Dropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    import currentUser from "@/store/modules/currentUser/currentUser";
    import MyAccount from "@/views/settings/MyAccount";
    import BusinessProfile from "@/views/settings/BusinessProfile";
    import Users from "@/views/settings/Users";
    import Axios from "axios";
    import {appConfig} from "@/config";
    import SettingsClaims from "@/views/settings/settings-claims";

    export default {
    name: "settings",
    components: {
        MyAccount,
        vueDropzone: vue2Dropzone,
        multiselect: Multiselect,
        BusinessProfile,
        Users,
        SettingsClaims,
    },
    data() {
        return {
            isAddLocationPressed: 0,
            isSaveLocationPressed: 0,
            mainTabId: '',
            businessTabId: '',
            // users
            isUsersEdit: false,
            isAddNewUserClicked: false,
            lastSelectedUser: {
                id: '',
                username: '',
                firstName: '',
                lastName: '',
                email: '',
                companyRole: '',
                businessLocation: '',
                userPhoto: '',
                mobilePhone: '',
                workPhone: '',
                lastLoggedIn: '',
                activeSessions: -1,
                password: '',
                confirmPassword: '',
            },
            selectedUser: {
                id: '',
                username: '',
                firstName: '',
                lastName: '',
                email: '',
                companyRole: '',
                businessLocation: '',
                userPhoto: '',
                mobilePhone: '',
                workPhone: '',
                lastLoggedIn: '',
                activeSessions: -1,
                password: '',
                confirmPassword: '',
            },
            usersAll: [],
            brands: [],
            usersAllFields: [
                {
                    label: "Name",
                    key: "username",
                    tdClass: "name clickable",
                    thClass: "table-header"
                },
                {
                    label: "Role",
                    key: "companyRole",
                    tdClass: "role clickable",
                    thClass: "table-header"
                },
                {
                    label: "",
                    key: "actions",
                    tdClass: "actions clickable text-right",
                    thClass: "table-header"
                }
            ],
            selectedUserAvatarDropdownOptions: {
                headers: {Authorization: localStorage.getItem("token")},
                resizeWidth: 400,
                resizeQuality: 0.7,
                url: 'url', // need to input dynamic url
                method: "post",
                maxFilesize: 5,
                thumbnailWidth: 160,
                thumbnailHeight: 160,
                addRemoveLinks: false,
                acceptedFiles: "image/jpeg, image/jpg, image/png",
                dictFileTooBig:
                    "Your file has exceeded the maximum limit of 5MB per file. Please reduce the file size and upload again"
            },

            // my account
            selectedBrand: '',
            myAccountAvatar: '',
            companyRole: '',
            currentPassword: "",
            newPassword: "",
            confirmPassword: "",
            isEditMode: false,
            isActiveMyAccount: true,
            currentUserLocation: '',
            myAccountDropzoneOptions: {
                headers: {Authorization: localStorage.getItem("token")},
                resizeWidth: 400,
                resizeQuality: 0.7,
                url: appConfig.baseAPIURL + "/ir/user/photo/upload",
                method: "post",
                maxFilesize: 5,
                thumbnailWidth: 160,
                thumbnailHeight: 160,
                addRemoveLinks: false,
                acceptedFiles: "image/jpeg, image/jpg, image/png",
                dictFileTooBig:
                    "Your file has exceeded the maximum limit of 5MB per file. Please reduce the file size and upload again"
            },

            // business profile
            contactFields: [
                {
                    label: "Name",
                    key: "username",
                    sortable: true,
                    tdClass: "table-body font-weight-bold",
                    thClass: "table-header"
                },
                {
                    label: "Position",
                    key: "companyRole",
                    sortable: true,
                    tdClass: "table-body",
                    thClass: "table-header"
                },
                {
                    label: "Office Phone",
                    key: "workPhone",
                    sortable: true,
                    tdClass: "table-body",
                    thClass: ""
                },
                {
                    label: "Mobile Phone",
                    key: "mobilePhone",
                    sortable: true,
                    tdClass: "table-body",
                    thClass: "table-header"
                },
                {
                    label: "Email",
                    key: "email",
                    sortable: true,
                    tdClass: "table-body",
                    thClass: "table-header"
                },
                {
                    label: "Location",
                    key: "businessLocation",
                    sortable: true,
                    tdClass: "table-body",
                    thClass: "table-header"
                },
                {
                    label: "Action",
                    key: "action",
                    sortable: true,
                    tdClass: "table-body text-center",
                    thClass: "table-header text-center"
                }
            ],
            locationFields: [
                {
                    label: "Name",
                    key: "name",
                    sortable: true,
                    tdClass: "table-body font-weight-bold",
                    thClass: "table-header"
                },
                {
                    label: "Address",
                    key: "address",
                    sortable: true,
                    tdClass: "table-body",
                    thClass: "table-header"
                },
                {
                    label: "Suburb",
                    key: "suburb",
                    sortable: true,
                    tdClass: "table-body",
                    thClass: "table-header"
                },
                {
                    label: "State",
                    key: "state",
                    sortable: true,
                    tdClass: "table-body",
                    thClass: "table-header"
                },
                {
                    label: "Postcode",
                    key: "postcode",
                    sortable: true,
                    tdClass: "table-body",
                    thClass: "table-header"
                },
                {
                    label: "Phone",
                    key: "phone",
                    sortable: true,
                    tdClass: "table-body",
                    thClass: "table-header"
                },
                {
                    label: "Open Hours",
                    key: "openHours",
                    sortable: true,
                    tdClass: "table-body",
                    thClass: "table-header"
                },
                {
                    label: "Closing Hours",
                    key: "closingHours",
                    sortable: true,
                    tdClass: "table-body",
                    thClass: "table-header"
                },
                {
                    label: "Delivery",
                    key: "delivery",
                    sortable: true,
                    tdClass: "table-body",
                    thClass: "table-header"
                },
                {
                    label: "Action",
                    key: "action",
                    sortable: true,
                    tdClass: "table-body",
                    thClass: "table-header action-btns"
                }
            ],

            companyInfo: {
                businessName: '',
                abn: '',
                businessType: '',
                phone: '',
                fax: '',
                email: '',
                brands: [],
                deleteBrands: [],
                logoImgPath: '',
                activeXeroAuth: false,
                address: {
                    address: '',
                    unitLevelLot: '',
                    street: '',
                    suburb: '',
                    postcode: '',
                    state: '',
                    country: ''
                },
            },
            initialBrands: [],
            locations: [],
            deleteLocations: [],
            contacts: [],
            contactsVisibility: {
                visible: [],
                inVisible: []
            },
            selectedLocation: {
                id: '',
                name: '',
                address: '',
                suburb: '',
                state: '',
                postcode: '',
                phone: '',
                openHours: '',
                closingHours: '',
                delivery: '',
            },
            businessTypes: [
                'Auto Body Repairer',
                'Motorbike Repairer',
                'Truck Repairer'
            ],
            supplierBusinessTypes: [
                {
                    value: 'OEM',
                    label:'OEM - Original Equipment Manufacturer'
                },
                {
                    value: 'AFTM',
                    label:'AFT-M - After-Market',
                },
                {
                    value: 'USED',
                    label:'USED - Used Parts',
                },
                {
                    value: 'RECO',
                    label: 'RECO - Reconditioned Parts'
                }
            ],
            deliveryOptions: [
                'Road'
            ],
            addUserTrigger: 0,
            xeroAuth: {
              tenantId: null,
              tenants: [],
              defaultInvoiceStatus: null,
              defaultGstSetting: null,
              defaultLineItemCode: null,
              autoUpdateInvoice: null,
              autoDeleteInvoice: null,
              invoiceReferenceDesc: null,
              invoiceDueDate: null,
            },
            xeroStatuses: {
              DRAFT: 'Draft',
              SUBMITTED: 'Submitted',
              AUTHORISED: 'Authorised',
            },
            invoiceReferenceDescs: {
              ClaimNumber: 'Claim Number',
              AssessmentNumber: 'Assessment Number',
              Rego: 'Rego',
              LegalRef: 'Legal Ref',
            },
            invoiceDueDates: {
              Today: 'Today',
              In7Days: 'In 7 Days',
              In14Days: 'In 14 Days',
              In30Days: 'In 30 days',
              FirstDayOfNextMonth: '1st day of Next Month',
              LastDayOfNextMonth: 'Last day of Next month',
            },
            xeroGstSettings: {
              Inclusive: 'Inclusive',
              Exclusive: 'Exclusive',
            },
            xeroAuthEditable: false,
            xeroToggleVariants: [
              {
                value: true,
                label: 'Enabled'
              },
              {
                value: false,
                label: 'Disabled'
              },
            ],
        };
    },
    mounted() {
        this.$nextTick(() => {
            if (this.$route.hash) {
                let hash = this.$route.hash;
                this.$refs['settings-table'].selectTab(hash);
            }
        });
        //this.tabId = this.$refs.users.id;
        // this.loadBrandList();
        if (!_.isEmpty(this.currentUser)) {
            this.myAccountAvatar = this.currentUser.userPhoto;
            this.companyRole = this.currentUser.companyRole;
            this.currentUserLocation = this.getLocationById(this.currentUser.businessLocation);
        }
        if (!_.isEmpty(this.initialLocations)) {
            this.setLocations(this.initialLocations);
            this.currentUserLocation = this.getLocationById(this.currentUser.businessLocation);
            this.updateSelectedUser(this.usersAll[0]);
        }
        this.setContacts(this.usersAll);
        this.loadXeroAuthData();

    },
    computed: {
        ...mapGetters({
            originalCompanyInfo: "currentCompany/getDetails",
            currentUser: "currentUser/getCurrentUserInfo",
            addressStates: 'addressStates',
            addressCountries: 'addressCountries',
            isUserRoleAssessor: 'currentUser/isRoleAssessor',
            isUserRoleLawyer: 'currentUser/isRoleLawyer',
        }),
    },
    methods: {
        ...mapActions({
            updateUserAvatar: 'currentUser/updateUserAvatar',
            //loadBrandList: 'brandList/loadBrandList',
        }),
      loadXeroAuthData(){
        Axios.get(`/ir/company/get-xero-auth`)
            .then(response => {
              if(response.data && response.data._status){
                if(response.data.data){
                  this.xeroAuth = response.data.data
                  setTimeout(() => {
                    this.xeroAuthEditable = true;
                  }, 300)
                } else {
                  this.xeroAuth = {
                    tenantId: null,
                    tenants: [],
                    defaultInvoiceStatus: null,
                    defaultGstSetting: null,
                    defaultLineItemCode: null,
                  };
                }
              }
            })
            .catch(e => console.error(e))
      },
      saveXeroAuthData(){
        Axios.post(`/ir/company/update-xero-auth`, this.xeroAuth)
            .then(response => {
              if(response.data && response.data._status){
                this.$toast.success('Xero settings has been updated successfully!')
              }
            })
            .catch(e => console.error(e))
      },
      connectToXero(){
        let wnd = window.open(`${appConfig.baseAPIURL}/settings/xero-oauth-start`, 'xero-auth-window', 'width=800,height=600,location=on');
        window.addEventListener('message', e => {
          console.log(e);
          let data = e.data;
          wnd.close();

          data = JSON.parse(data);
          console.log(data);

          Axios.post(`/ir/company/set-xero-auth`, data)
              .then(response => {
                if(response.data && response.data._status){
                  this.$store.dispatch('currentCompany/loadCompanyInfo', {}, {root: true});
                  this.loadXeroAuthData();
                }
              })
              .catch(e => console.error(e))

        })
      },
      disconnectFromXero(){
        Axios.post(`/ir/company/remove-xero-auth`)
            .then(response => {
              if(response.data && response.data._status){
                this.$store.dispatch('currentCompany/loadCompanyInfo', {}, {root: true});
              }
            })
            .catch(e => console.error(e))
      },
        onCurrentUserSelected(){
          this.$refs['settings-table'].selectTab('#settings-account');
        },
        getBusinessTypes() {
            return [];
        },
        onApiKeyCreateClick: function(){
            this.$refs.integrationsComponent.onCreateClick();
        },

        // users methods
        onClickAddNewUser: function () {
            this.isAddNewUserClicked = true;
        },
        onClickCancelEditUser: function () {
            this.isAddNewUserClicked = false;
        },
        onClickSaveUser: function () {
            this.addUserTrigger++;
        },
        updateUser: function (user) {
            NProgress.start();
            this.$store.dispatch('users/updateUser', {
                id: user.id,
                updatedUser: user
            }).then(() => {
                this.$toast.success('User has been updated');
                NProgress.done();
                if (Number(this.currentUser.id) === Number(this.selectedUser.id)) {
                    this.$store.dispatch('currentUser/loadUserInfo')
                        .then((res) => {
                        })
                        .catch((err) => {
                            this.$toast.error('err')
                        });
                }
            }).catch((err) => {
                this.$toastr.w(err);
                NProgress.done();
            });

        },
        onClickUpdateUser: function () {
            this.updateUser(this.selectedUser);
            this.isUsersEdit = false;
            this.isAddNewUserClicked = false;
        },
        setUploadUrlForUsersPhoto: function (id) {
            if (!_.isEmpty(this.$refs.imgUpDropUsers)) {
                let url = appConfig.baseAPIURL + "/ir/user/" + id + "/photo/upload";
                this.$refs.imgUpDropUsers.setOption('url', url);
            }
        },
        onUsersRowClick: function (item) {
            this.setUploadUrlForUsersPhoto(item.id);
            this.updateSelectedUser(item);
            this.isUsersEdit = false;
            this.isAddNewUserClicked = false;
        },
        onUserEdit: function (item) {
            this.updateSelectedUser(item);
            this.isUsersEdit = true;
            this.isAddNewUserClicked = false;
        },
        onClickRemoveUser: function (item) {
            let userId;
            NProgress.start();

            if (!item) userId = this.selectedUser.id
            else userId = item.id;

            this.$store.dispatch('users/removeUserById', userId)
                .then(() => {
                    this.$toast.success('User has been removed');
                    NProgress.done();
                })
                .catch((err) => {
                    this.$toastr.w(err);
                    NProgress.done();
                })
            this.updateSelectedUser({});
        },
        onClickCloseActiveSessions: function () {
            NProgress.start();
            this.$store.dispatch('users/closeActiveSessions', this.selectedUser.id)
                .then(() => {
                    if (Number(this.selectedUser.id) === Number(this.currentUser.id)) {
                        this.$store.dispatch('auth/logout');
                    }
                    this.$toast.success('Active sessions have been closed');
                    NProgress.done();
                })
                .catch((err) => {
                    this.$toastr.w(err);
                    NProgress.done();
                })
            this.isUsersEdit = false;
            isAddNewUserClicked = false;
        },
        onClickUpdatePassword: function () {
            if(Number(this.currentUser.id) === Number(this.selectedUser.id)){
                this.onUpdatePasswordMyAccount({
                    currentPassword: this.selectedUser.currentPassword,
                    newPassword: this.selectedUser.password,
                    confirmPassword: this.selectedUser.confirmPassword
                }, () => {
                    this.selectedUser.currentPassword = '';
                    this.selectedUser.password = '';
                    this.selectedUser.confirmPassword = '';
                });
            }else {
                if (!this.validateSelectedUserPassword()) return;
                NProgress.start();
                this.$store.dispatch('users/updatePasswordById', {
                    id: this.selectedUser.id,
                    password: this.selectedUser.password,
                    confirmNewPassword: this.selectedUser.confirmPassword
                }).then(() => {
                    this.$toast.success('Password has been updated');
                    this.selectedUser.password = '';
                    this.selectedUser.confirmPassword = '';
                }).catch(err => {
                    this.$toast.error(err);
                }).finally( () => {
                    NProgress.done();
                });
            }


        },
        onUnlockPassword: function () {
        },
        onClickDeletePhoto() {
            this.selectedUser.userPhoto = '';
            if (Number(this.currentUser.id) === this.selectedUser.id) {
                this.myAccountAvatar = '';
                this.updateUserAvatar('');
            }
            NProgress.start();
            this.$store.dispatch('users/removeUserPhotoById', this.selectedUser.id)
                .then(() => {
                    this.$toast.success('User photo has been removed');
                    NProgress.done();
                    this.$store.dispatch('users/fetchAllUsers').catch(err => {
                        this.$toast.error(err)
                    });
                })
                .catch(error => {
                    this.$toastr.w(error);
                    NProgress.done();
                });
        },
        updateSelectedUser: function (data) {
            let location = {},
                locationId = 0;
            if (!_.isEmpty(data)) {
                locationId = data.businessLocation;
                location = this.getLocationById(locationId);

                this.selectedUser = {
                    id: data.id,
                    username: data.username,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    email: data.email,
                    companyRole: data.companyRole,
                    isActive: data.isActive,
                    businessLocation: locationId,
                    location: location,
                    userPhoto: data.userPhoto,
                    mobilePhone: data.mobilePhone,
                    workPhone: data.workPhone,
                    activeSessions: data.activeSessions,
                    lastLoggedIn: data.lastLoggedIn
                };
            } else {
                this.selectedUser = {
                    id: '',
                    username: '',
                    firstName: '',
                    lastName: '',
                    email: '',
                    companyRole: '',
                    businessLocation: '',
                    userPhoto: '',
                    mobilePhone: '',
                    workPhone: '',
                    lastLoggedIn: '',
                    activeSessions: -1,
                    password: '',
                    confirmPassword: '',
                }
            }
        },

        // my account methods
        onEditAccount: function () {
            this.isEditMode = true;
        },
        onCancelEditAccount: function () {
            this.isEditMode = false;
        },
        onCloseActiveSessionsMyAccount: function () {
            this.$store.dispatch('currentUser/closeActiveSessions')
                .then((res) => {
                    this.$toast.success('Active sessions are closed successfully')
                    this.$store.dispatch('auth/logout');
                })
                .catch((err) => {
                    this.$toast.error('err')
                })
        },
        onRemoveMyAccountPhoto: function () {
            NProgress.start();
            this.myAccountAvatar = '';
            this.updateUserAvatar('');
            this.$store.dispatch('currentUser/removeUserAvatar')
                .then(() => {
                    this.$toast.success('User photo has been removed');
                    NProgress.done();
                })
                .catch(error => {
                    this.$toastr.w(error);
                    NProgress.done();
                });
        },
        onUpdateMyAccountInfo: function () {
            const updatedUserInfo = {
                username: this.currentUser.username,
                email: this.currentUser.email,
                companyRole: this.companyRole,
                isActive: this.isActiveMyAccount,
                firstName: this.currentUser.firstName,
                lastName: this.currentUser.lastName,
                businessLocation: this.currentUserLocation.id,
                workPhone: this.currentUser.workPhone,
                mobilePhone: this.currentUser.mobilePhone,
            };
            this.$store.dispatch('currentUser/updateCurrentUser', updatedUserInfo)
                .then(res => {
                    this.$toast.success('User has been updated successfully');
                    this.$store.dispatch('users/fetchAllUsers').catch(err => {
                        this.$toast.error(err)
                    });
                }).catch(err => {
                this.$toast.error(err)
            })
            this.isEditMode = false;
        },
        onUpdatePasswordMyAccount: function (data = {}, onSuccess=()=>{}) {
            let password = data;
            if(_.isEmpty(password)) {
                password = {
                    currentPassword: this.currentPassword,
                    newPassword: this.newPassword,
                    confirmPassword: this.confirmPassword
                }
            }

            password.id = currentUser.id;
            this.$store.dispatch('currentUser/updateCurrentUserPassword', password)
                .then(res => {
                    if (res.data.status) {
                        this.$toast.success('User\'s password has been updated successfully');
                        onSuccess();
                    } else {
                        if(!_.isEmpty(res.data._err)) {
                            _.forEach(res.data._err, text => {
                                this.$toast.error(text);
                            });
                        }
                    }
                }).catch(err => {
                this.$toast.error(err);
            })
        },
        onUnLockPasswordMyAccount: function () {
        },
        // business profile methods

        removeBrand: function (removedOption) {
            console.log('removedOption', removedOption);
            this.companyInfo.brands.splice(this.companyInfo.brands.indexOf(removedOption), 1);
            this.companyInfo.deleteBrands.push(removedOption);
        },
        onClickSaveCompanyInfo: function () {
            saveDetails();
        },
        onClickAddLocation: function () {
          this.isAddLocationPressed++;
        },

        onClickEditRow: function (index) {
            let locations = JSON.parse(JSON.stringify(this.locations));
            let location = JSON.parse(JSON.stringify(locations[index]));
            let stateValue = _.find(this.addressStates, (item) => {
                return location.state === item.key;
            });
            for (let key in locations) {
                locations[key].isEditable = false;
            }
            this.selectedLocation = {
                id: location.id,
                name: location.name,
                address: location.address,
                suburb: location.suburb,
                state: location.state,
                stateValue: stateValue,
                postcode: location.postcode,
                phone: location.phone,
                openHours: location.openHours,
                closingHours: location.closingHours,
                delivery: location.delivery,
            };
            locations[index].isEditable = true;
            this.locations = locations;
            this.$refs.locationTable.refresh();
        },
        onClickSaveRow: function (index) {
            let locations = JSON.parse(JSON.stringify(this.locations));
            locations[index] = JSON.parse(JSON.stringify(this.selectedLocation));
            if (!_.isEmpty(this.selectedLocation.stateValue)) locations[index].state = this.selectedLocation.stateValue.key;
            this.locations = locations;
            this.refreshSelectedLocation();
            this.saveCompanyInfo();
        },
        onClickRemoveRow: function (index) {
            let location = this.locations[index],
                locations = this.locations;
            locations.splice(index, 1);
            if ('id' in location) this.deleteLocations.push(location.id);
            this.refreshSelectedLocation();
            this.locations = locations;
        },
        businessLocationUpdate: function (data) {
            let user = {
                id: data.id,
                businessLocation: data.location.id,
            };
            this.updateUser(user);
        },
        refreshSelectedLocation: function () {
            this.selectedLocation = {
                id: '',
                name: '',
                address: '',
                suburb: '',
                state: '',
                stateValue: '',
                postcode: '',
                phone: '',
                openHours: '',
                closingHours: '',
                delivery: '',
            }
            this.$refs.locationTable.refresh();
        },
        onMainTabChange: function (tab) {
            this.mainTabId = tab.tab.id;
        },
        onBusinessTabChange: function (tab) {
            console.log(tab);
            this.businessTabId = tab.tab.id;
        },

        successImgUploadSelectedUser(file, response) {
            if (response.status) {
                this.$set(this.selectedUser, 'userPhoto', file.dataURL);
                if (Number(this.currentUser.id) === this.selectedUser.id) {
                    this.updateUserAvatar(file.dataURL);
                }
                this.$store.dispatch('users/fetchAllUsers').catch(err => {
                    this.$toast.error(err)
                });
            } else {
                setTimeout(() => {
                    this.$refs.imgUpDropUsers.removeFile(file);
                }, 1000);
            }
        },
        successImgUploadMyAccount(file, response) {
            if (response.status) {
                this.updateUserAvatar(file.dataURL);
                this.myAccountAvatar = file.dataURL;
            } else {
                var vm = this;
                setTimeout(function () {
                    vm.$refs.imgUploadDropMyAccount.removeFile(file);
                }, 1000);
            }
        },

        validateSelectedUserEmail: function (value) {
            this.selectedUser.email = value;
            this.$v.selectedUser.email.$touch();
        },
        validateMyAccountEmail: function (value) {
            this.currentUser.email = value;
            this.$v.currentUser.email.$touch();
        },
        validateCompanyEmail: function (value) {
            this.companyInfo.email = value;
            this.$v.companyInfo.email.$touch();
        },
        validateSelectedUserPassword: function () {
            if (!this.selectedUser.password) {
                this.$toast.error('Please input the password!');
                return false;
            }
            if (this.selectedUser.password != this.selectedUser.confirmPassword) {
                this.$toast.error('Passwords do not match!');
                return false;
            }
            return true;
        },
        getLocationById: function (id) {
            let location = {};
            if (!_.isEmpty(this.locations)) {
                location = _.find(this.locations, (location) => {
                    return id === location.id;
                });
            }
            return location;
        },
        setLocations: function (val) {
            this.locations = val.map(location => ({
                ...location,
                isEditable: false,
                stateValue: _.find(this.addressStates, item => {
                    return item.key === location.state;
                })
            }));
        },
        setContacts: function (usersAll) {
            if (!_.isEmpty(usersAll)) {
                this.contacts = null;
                let contacts = [];
                _.forEach(usersAll, (item) => {
                    let contact = item;
                    contact.location = this.getLocationById(item.businessLocation);
                    contacts.push(contact);
                });
                this.contacts = contacts;
            }
        },
    },
    watch: {
        xeroAuth: {
          deep: true,
          handler() {
            if(this.xeroAuthEditable){
              this.saveXeroAuthData();
            }
          }
        },
        selectedBrand: function (newVal) {
            if (!newVal) return;
            if (this.companyInfo.brands.includes(newVal)) return;
            this.companyInfo.brands.push(newVal);
            this.companyInfo.brands = this.companyInfo.brands.filter((elem, pos, arr) => {
                return arr.indexOf(elem) === pos;
            });
        },
        currentUser: {
            deep: true,
            handler(val) {
                this.myAccountAvatar = val.userPhoto;
                this.companyRole = val.companyRole;
                this.currentUserLocation = this.getLocationById(val.businessLocation);
            }
        },
        selectedUser: {
            deep: true,
            handler(newVal, oldVal) {
                this.setUploadUrlForUsersPhoto(newVal.id);
                if (!_.isEmpty(newVal.location)) this.selectedUser.businessLocation = newVal.location.id;
            }
        },
        usersAll: {
            deep: true,
            handler(val) {
                if (!_.isEmpty(val) && _.isEmpty(this.selectedUser.firstName)) {
                    this.updateSelectedUser(val[0]);
                }
                this.setContacts(val);
            }
        },
        initialCompanyInfo: {
            deep: true,
            handler(val) {
                console.log('watch', 'initialCompanyInfo');
            }
        },
        initialLocations: {
            deep: true,
            handler(val) {
                this.setLocations(val);
                this.setContacts(this.usersAll);
                this.updateSelectedUser(this.usersAll[0]);
                this.currentUserLocation = this.getLocationById(this.currentUser.businessLocation);
            }
        }
    },
    validations: {
        selectedUser: {
            email: {
                email
            }
        },
        currentUser: {
            email: {
                email
            }
        },
        companyInfo: {
            email: {
                email
            }
        }
    }
};
</script>

<style>
.location_delivery {
    min-width: 153px;
}

.settings-page .table-header {
    border: none !important;
}

.settings-page .table-responsive {
    border-radius: 3px;
    background-color: rgba(27, 30, 56, 0.1);
    overflow-x: initial !important;
}

.settings-page .tab-content-table {
    padding-top: 12px;
}

.settings-page .table td {
    border-bottom: 1px solid #dee2e6 !important;
}

.settings-page .table td.name {
    font-size: 12px;
    font-weight: bold;
}

.settings-page .table td.role {
    font-size: 12px;
}

.settings-page .btn-edit {
    background: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTlweCIgaGVpZ2h0PSIxOXB4IiB2aWV3Qm94PSIwIDAgMTkgMTkiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA2MiAoMTAxMDEwKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT5BQkU0Q0UxRi0yMDAyLTQ2QTEtQTVBMS0yRTUwMDg0MDQ5MTE8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgogICAgPGcgaWQ9IlVJLURlc2lnbiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkRhc2hib2FyZC1SZWRlc2lnbi0oVmlldy1Bc3Nlc29ycykiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzc1LjAwMDAwMCwgLTEwMDYuMDAwMDAwKSIgZmlsbD0iIzFCMUUzOCIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGcgaWQ9IlJvdy0wMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjY1LjAwMDAwMCwgMTAwNS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJwZW5jaWwiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExMTAuMDAwMDAwLCAxLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMi4yMzgsNS40NzIgTDMuMiwxNC41MSBMMi42MDksMTYuNTI2IEw0LjU4NCwxNS45NTUgTDEzLjY1Miw2Ljg4NyBMMTIuMjM4LDUuNDcyIFogTTEzLjc4LDMuOTMgTDE1LjE5NCw1LjM0NCBMMTYuNTEyLDQuMDI2IEMxNi43MDcxOTEsMy44MzA3NTAwNyAxNi43MDcxOTEsMy41MTQyNDk5MyAxNi41MTIsMy4zMTkgTDE1LjgwNCwyLjYxMiBDMTUuNjA4NzUwMSwyLjQxNjgwOTAzIDE1LjI5MjI0OTksMi40MTY4MDkwMyAxNS4wOTcsMi42MTIgTDEzLjc4MSwzLjkzIEwxMy43OCwzLjkzIFogTTE3LjIxOSwxLjE5OCBMMTcuOTI2LDEuOTA1IEMxOC45MDE5NTQ4LDIuODgxMjQ5NjMgMTguOTAxOTU0OCw0LjQ2Mzc1MDM3IDE3LjkyNiw1LjQ0IEw1LjYzNCwxNy43MzMgTDEuNDE0LDE4Ljk1MyBDMS4wNjM2NjE3LDE5LjA1NDAxMiAwLjY4NjExMjg5NCwxOC45NTYzNDA0IDAuNDI4NzExMjksMTguNjk4MTA2NSBDMC4xNzEzMDk2ODYsMTguNDM5ODcyNSAwLjA3NDg1NzQ1MiwxOC4wNjIwMTA0IDAuMTc3LDE3LjcxMiBMMS40MjUsMTMuNDU3IEwxMy42ODUsMS4xOTcgQzE0LjY2MTI0OTYsMC4yMjEwNDUxNTQgMTYuMjQzNzUwNCwwLjIyMTA0NTE1NCAxNy4yMiwxLjE5NyBMMTcuMjE5LDEuMTk4IFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=") no-repeat top left;
    border: none;
    width: 36px;
    height: 20px;
}

.settings-page .btn-trush {
    background: url("data:image/svg+xml;base64,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") no-repeat center left;
    border: none;
    width: 36px;
    height: 20px;
}

.settings-page .detail-section {
    border: 1px solid rgba(27, 30, 56, 0.1);
    border-radius: 3px;
}

.settings-page .section-header {
    padding: 1rem;
    font-size: 13px;
    font-weight: bold;
    border-bottom: 1px solid rgba(27, 30, 56, 0.1);
}

.settings-page .detail-body {
    padding: 1rem;
}

.settings-page .user-photo {
    text-align: center;
}

.settings-page .user-photo img {
    height: 164px;
    width: auto;
    border-radius: 3px;
}

.settings-page .user-avatar-section {
    padding-left: 0 !important;
}

.settings-page .user-avatar-section button {
    width: 100%;
    border-radius: 3px;
    color: #ffffff;
    font-size: 13px;
    font-weight: bold;
    background-color: #ff5e5e;
    margin-top: 10px;
}

.settings-page .user-name {
    margin-top: 6px;
    font-size: 21px;
    font-weight: bold;
}

.settings-page .active-user-text {
    margin-left: 12px;
}

.settings-page .user-detail-section {
    padding: 0 !important;
}

.settings-page .user-detail-section .col-form-label {
    padding-left: 6px !important;
}

.settings-page .user-detail-section .form-text {
    margin: 0;
    font-size: 12px;
    font-weight: 600;
}

.settings-page .action-btns {
    height: 30px;
    padding: 6px;
    justify-content: flex-end;
}

.settings-page .action-btns button {
    border-radius: 3px;
    font-size: 13px;
    font-weight: bold;
    background: none;
    margin-left: 5px;
    margin-right: 5px;
}

.settings-page .close-active-btn {
    height: 31px;
    border: 1px solid rgba(28, 31, 57, 0.25);
    color: #1c1f39;
    font-family: "Nunito Sans";
    background: none;
    font-weight: bold;
}

.settings-page .delete-user {
    height: 31px;
    border: 1px solid #ff5e5e;
    border-radius: 3px;
    color: #ff5e5e;
    background: none;
    font-family: "Nunito Sans";
    font-size: 13px;
    font-weight: bold;
}

.settings-page .update-password-section {
    margin-top: 15px;
    margin-bottom: 15px;
    border: 1px solid rgba(27, 30, 56, 0.1);
    border-radius: 3px;
}

.settings-page .unlock-btn {
    height: 31px;
    width: 101px;
    border: 1px solid rgba(28, 31, 57, 0.25);
    border-radius: 3px;
    background: none;
    font-size: 13px;
    font-weight: bold;
}

.settings-page .active-icon {
    height: 8px;
    width: 8px;
    background-color: #2dca73;
    border-radius: 50%;
    position: absolute;
    margin-top: 4px;
}

.settings-page .active-icon.inactive {
    background-color: lightgray;
}

.settings-page .edit-active-icon {
    margin-top: 9px;
}

.settings-page .custom-switch {
    margin-top: 0px;
    padding-left: 3.25rem;
}

.settings-page .status-text {
    margin-left: 36px;
    margin-top: 4px;
}

.settings-page
.custom-switch
.custom-control-input:checked
~ .custom-control-label::after {
    height: 19px;
    width: 19px;
    border-radius: 11.5px;
    background-color: #ffffff;
    transform: translateX(0rem);
}

.settings-page .custom-switch .custom-control-label::after {
    height: 19px;
    width: 19px;
    border-radius: 11.5px;
    background-color: #ffffff;

    transform: translateX(1.25rem);
}

.settings-page .custom-switch .custom-control-label::before {
    width: 39px;
    height: 23px;
    border-radius: 11.5px;
    border-color: lightgray;
    background-color: lightgray;
}


.settings-page .upload-title {
    font-size: 13px;
    font-weight: bold;
    color: #1c1f39;
}

.settings-page .business-profile-tabs {
    width: 100%;
}

.settings-page .business-profile-tabs .tabs-component::after {
    /*height: 1px;*/
}

.settings-page .eye i {
    font-size: 20px;
    transform: scaleX(-1);
    cursor: pointer;
}

/* .settings-page .action-btns {
  width: 115px;
}

.settings-page .action-btn button {
  width: 20px;
  margin-right: 20px;
} */

.settings-page .tab-content {
    padding-left: 0;
    padding-right: 0;
}

.settings-page .table-header {
    font-size: 13px;
    font-weight: bold;
    border: none !important;
}

.settings-page .table-body {
    font-size: 12px;
    font-weight: 600;
}

.settings-page .card-header {
    font-size: 13px;
    font-weight: bold;
    border: none !important;
    height: 48px;
    padding: 15px !important;
}

.settings-page .dropzoneContainer {
    margin: 15px 0 20px 0;
    width: auto;
    height: 184px;
    border: 1px dashed rgba(27, 30, 56, 0.25);
    border-radius: 3px;
    background: white !important;
    height: auto;
    font-family: "Nunito Sans";
    font-size: 13px;
    font-weight: bold;
}

.settings-page
.dropify-wrapper
.dropify-message
span.file-icon:before {
    content: "\E800";
    font-weight: 800;
    font-size: 37px;
    color: blue;
}

.settings-page .browse-btn {
    height: 38px;
    width: 100px;
    padding: 0;
    border-radius: 3px;
    font-family: "Nunito Sans";
    font-size: 13px;
    font-weight: bold;
}

.settings-page .cancel-btn {
    margin-left: 10px;
    box-sizing: border-box;
    height: 38px;
    width: 100px;
    border: 1px solid rgba(28, 31, 57, 0.25);
    border-radius: 3px;
}

.settings-page .dnd-title {
    color: #1c1f39;
    font-family: "Nunito Sans";
    font-size: 13px;
    font-weight: bold;
}

.settings-page .text-or {
    opacity: 0.25;
    color: #1c1f39;
    font-family: "Nunito Sans";
    font-size: 13px;
    font-weight: bold;
}


.settings-page .drop-down-text {
    color: #1c1f39;
    font-size: 13px;
    font-weight: 700;
}

.settings-page .business-details .col-md-5 {
    padding-left: 0;
}

.settings-page .multiselect__select:before {
    font-size: 23px;
}

.multiselect__option {
    height: 40px;
}
</style>
